import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import { translations, LANG_CODES } from "./translations";

const LanguageContext = createContext(null);

const STORAGE_KEY = "sapientia.lang";

function detectDefault() {
  if (typeof window === "undefined") return "pt";
  try {
    const stored = window.localStorage.getItem(STORAGE_KEY);
    if (stored && LANG_CODES.includes(stored)) return stored;
    const nav = (window.navigator.language || "pt").slice(0, 2).toLowerCase();
    if (LANG_CODES.includes(nav)) return nav;
  } catch {
    // ignore
  }
  return "pt";
}

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(detectDefault);

  useEffect(() => {
    try {
      window.localStorage.setItem(STORAGE_KEY, lang);
      document.documentElement.lang = lang;
    } catch {
      // ignore
    }
  }, [lang]);

  const setLang = (next) => {
    if (LANG_CODES.includes(next)) setLangState(next);
  };

  const value = useMemo(
    () => ({
      lang,
      setLang,
      t: translations[lang] || translations.pt,
      codes: LANG_CODES,
    }),
    [lang]
  );

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
}

export function useLang() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used inside LanguageProvider");
  return ctx;
}
